import React from 'react';
import { useLanguage } from '../i18n/LanguageContext';

const MoneyPanel = ({ money, onReset, handsPlayed, onMoreStats }) => {
  const { t } = useLanguage();

  return (
    <div className="space-y-3">
      {/* Your Money Panel */}
      <div 
        className="rounded-xl p-4 relative overflow-hidden"
        style={{ 
          background: 'linear-gradient(145deg, rgba(26,26,46,0.95), rgba(22,33,62,0.95))',
          border: '1px solid rgba(255,215,0,0.3)',
          boxShadow: '0 4px 20px rgba(0,0,0,0.4), 0 0 20px rgba(255,215,0,0.1)'
        }}
      >
        {/* Decorative corner */}
        <div className="absolute top-0 right-0 w-16 h-16 opacity-20" style={{
          background: 'radial-gradient(circle at top right, #ffd700, transparent 70%)'
        }}></div>
        
        <div className="flex justify-between items-start mb-2">
          <span className="text-xs font-bold tracking-wider" style={{ color: '#ffd700' }}>
            💰 {t('yourBalance')}
          </span>
          <button 
            onClick={onReset}
            className="text-xs font-medium px-2 py-0.5 rounded transition-all hover:scale-105"
            style={{ 
              color: '#ff6b6b',
              background: 'rgba(255,107,107,0.1)',
              border: '1px solid rgba(255,107,107,0.3)'
            }}
          >
            {t('reset')}
          </button>
        </div>
        <div 
          className="text-4xl font-black"
          style={{ 
            background: 'linear-gradient(180deg, #00ff88 0%, #00cc6a 100%)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            textShadow: '0 0 20px rgba(0,255,136,0.3)'
          }}
        >
          ${money.toLocaleString()}
        </div>
      </div>

      {/* Stats Panel */}
      <div 
        className="rounded-xl p-4 flex items-center justify-between"
        style={{ 
          background: 'linear-gradient(145deg, rgba(26,26,46,0.95), rgba(22,33,62,0.95))',
          border: '1px solid rgba(255,215,0,0.3)',
          boxShadow: '0 4px 15px rgba(0,0,0,0.3)'
        }}
      >
        <button 
          onClick={onMoreStats}
          className="flex items-center gap-2 text-sm font-medium transition-all hover:scale-105"
          style={{ color: '#ffd700' }}
        >
          <span className="text-lg">📊</span>
          <span className="text-xs">{t('viewStats')}</span>
        </button>
        <div className="text-right">
          <div className="text-xs font-bold tracking-wider" style={{ color: '#888' }}>{t('handsPlayed')}</div>
          <div className="text-3xl font-black" style={{ color: '#ffd700' }}>{handsPlayed}</div>
          <div className="text-xs" style={{ color: '#666' }}>{t('today')}</div>
        </div>
      </div>
    </div>
  );
};

export default MoneyPanel;
